// schema
import * as ISchema from "#webapp/src/__schema__";

//////////////////
// TYPES
//////////////////
export enum EDeltaTagType {
  Best = "Best",
  Soonest = "Soonest",
  Good = "Good",
}

export interface IDeltaInfo {
  dateText: string;
  hasRooms: boolean;
  isBest: boolean;
  isGood: boolean;
  isSoon: boolean;
  rooms: ISchema.IRoom[];
  scoreText: string;
  scoreSuffix: string;
  tagText: string;
}

// get the FocusTime diff in a nicely formatted string
export function getScoreText(score: number) {
  if (score === 0) {
    return "No impact";
  }
  let scoreText = score > 0 ? "+" : "";
  scoreText += score % 1 === 0 ? score : score.toFixed(1);
  scoreText += " hr";
  return scoreText;
}

export function getScoreSuffix(score: number) {
  return score === 0 ? " on Focus Time" : " Focus Time";
}

// get the FocusTime diff in a nicely formatted string
export function getFocusTimeSuffix(attendees?: boolean, numAttendees?: number) {
  let suffix = "";

  if (numAttendees) {
    suffix += ` for ${numAttendees} attendee${numAttendees === 1 ? "" : "s"}`;
  } else if (attendees) {
    suffix += " for attendees";
  }

  return suffix;
}
